"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "deleteBackground", {
  enumerable: true,
  get: function get() {
    return _deleteBackground["default"];
  }
});
Object.defineProperty(exports, "getBackgrounds", {
  enumerable: true,
  get: function get() {
    return _getBackgrounds["default"];
  }
});
Object.defineProperty(exports, "syncBackgroundStatus", {
  enumerable: true,
  get: function get() {
    return _syncBackgroundStatus["default"];
  }
});
Object.defineProperty(exports, "toggleBackgroundHidden", {
  enumerable: true,
  get: function get() {
    return _toggleBackgroundHidden["default"];
  }
});
Object.defineProperty(exports, "updateEventDocUploadStatus", {
  enumerable: true,
  get: function get() {
    return _updateEventDocUploadStatus["default"];
  }
});
Object.defineProperty(exports, "uploadBackground", {
  enumerable: true,
  get: function get() {
    return _uploadBackground["default"];
  }
});
var _getBackgrounds = _interopRequireDefault(require("./getBackgrounds"));
var _syncBackgroundStatus = _interopRequireDefault(require("./syncBackgroundStatus"));
var _toggleBackgroundHidden = _interopRequireDefault(require("./toggleBackgroundHidden"));
var _uploadBackground = _interopRequireDefault(require("./uploadBackground"));
var _updateEventDocUploadStatus = _interopRequireDefault(require("./updateEventDocUploadStatus"));
var _deleteBackground = _interopRequireDefault(require("./deleteBackground"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }